"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconNames = exports.icons = exports.viewBox = void 0;
exports.viewBox = '0 0 24 24';
exports.icons = {
    accident: [
        {
            component: 'path',
            props: {
                d: 'M17 2v2h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3V2h10ZM7 6H5v14h14V6h-2v2H7V6Zm6 5v2h2v2h-2.001L13 17h-2l-.001-2H9v-2h2v-2h2Zm2-7H9v2h6V4Z',
            },
        },
    ],
    'add-file': [
        {
            component: 'path',
            props: {
                d: 'M15 4H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992ZM11 12V9h2v3h3v2h-3v3h-2v-3H8v-2h3Z',
            },
        },
    ],
    'add-someone': [
        {
            component: 'path',
            props: {
                d: 'M12 13.429a5.713 5.713 0 0 1-5.715-5.715A5.713 5.713 0 0 1 11.999 2a5.713 5.713 0 0 1 5.714 5.714A5.713 5.713 0 0 1 12 13.43Zm0-1.905a3.808 3.808 0 0 0 3.809-3.81 3.808 3.808 0 0 0-3.81-3.81 3.808 3.808 0 0 0-3.81 3.81 3.808 3.808 0 0 0 3.81 3.81ZM4.38 22A7.62 7.62 0 0 1 12 14.381v1.905A5.714 5.714 0 0 0 6.284 22H4.38ZM16.263 14.381v2.857h-2.842v1.905h2.842V22h1.895v-2.857H21v-1.905h-2.842v-2.857h-1.895Z',
            },
        },
    ],
    'advertising-and-marketing': [
        {
            component: 'path',
            props: {
                d: 'M9 17C9 17 16 18 19 21H20C20.5523 21 21 20.5523 21 20V13.937C21.8626 13.715 22.5 12.9319 22.5 12C22.5 11.0681 21.8626 10.285 21 10.063V4C21 3.44772 20.5523 3 20 3H19C16 6 9 7 9 7H5C3.89543 7 3 7.89543 3 9V15C3 16.1046 3.89543 17 5 17H6L7 22H9V17ZM11 8.6612C11.6833 8.5146 12.5275 8.31193 13.4393 8.04373C15.1175 7.55014 17.25 6.77262 19 5.57458V18.4254C17.25 17.2274 15.1175 16.4499 13.4393 15.9563C12.5275 15.6881 11.6833 15.4854 11 15.3388V8.6612ZM5 9H9V15H5V9Z',
            },
        },
    ],
    apple: [
        {
            component: 'path',
            props: {
                d: 'M15.991 7.463c-.427-.033-.886.069-1.588.337.06-.023-.67.262-.875.334-.453.158-.826.245-1.244.245-.414 0-.795-.083-1.234-.23-.14-.049-.28-.1-.456-.169l-.404-.16c-.585-.229-.915-.316-1.189-.308-1.04.013-2.025.614-2.597 1.609-1.166 2.026-.52 5.688 1.185 8.155.909 1.305 1.405 1.77 1.606 1.764.2-.009.347-.051.707-.203l.15-.064c.908-.388 1.545-.558 2.503-.558.922 0 1.538.168 2.41.543l.151.065c.36.154.49.188.715.183.324-.005.722-.377 1.606-1.675a8.87 8.87 0 0 0 .641-1.101c-.122-.1-.24-.205-.354-.314-1.164-1.109-1.884-2.604-1.904-4.452-.019-1.367.43-2.7 1.274-3.775a3.724 3.724 0 0 0-1.103-.226Zm.14-1.8c.64.043 2.47.238 3.663 1.982-.098.055-2.19 1.268-2.167 3.804.032 3.034 2.655 4.042 2.687 4.053a10.896 10.896 0 0 1-1.387 2.85c-.834 1.225-1.701 2.438-3.067 2.46-1.344.032-1.777-.791-3.305-.791-1.539 0-2.016.77-3.284.823-1.322.044-2.319-1.322-3.164-2.535-1.723-2.493-3.034-7.023-1.268-10.09.878-1.527 2.439-2.492 4.14-2.513 1.29-.033 2.514.867 3.305.867.78 0 2.178-1.04 3.847-.91Zm-1.03-1.648c-.704.845-1.852 1.506-2.969 1.42-.151-1.149.412-2.352 1.062-3.1.726-.845 1.94-1.473 2.948-1.517.13 1.17-.336 2.352-1.04 3.197Z',
            },
        },
    ],
    archive: [
        {
            component: 'path',
            props: {
                d: 'M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm17 11h-3.416a5.002 5.002 0 0 1-9.168 0H4v5h16v-5Zm0-2V5H4v7h5a3 3 0 0 0 6 0h5Z',
            },
        },
    ],
    'arrow-down': [
        {
            component: 'path',
            props: {
                d: 'M12 22 2 12l1.43-1.43L11 18.14V2h2v16.14l7.57-7.57L22 12 12 22Z',
            },
        },
    ],
    'arrow-left': [
        {
            component: 'path',
            props: {
                d: 'M2 12 12 2l1.43 1.43L5.86 11H22v2H5.86l7.57 7.57L12 22 2 12Z',
            },
        },
    ],
    'arrow-left-brand': [
        {
            component: 'path',
            props: {
                d: 'm7.98 18.42 2.484-.54c-.216-2.138-1.836-4.126-3.564-4.644h13.5v-2.052H6.9c1.728-.518 3.348-2.506 3.564-4.644L7.98 6c-.108 3.11-1.923 4.946-4.86 5.184v2.052c2.938.238 4.752 2.074 4.86 5.184Z',
            },
        },
    ],
    'arrow-right': [
        {
            component: 'path',
            props: {
                d: 'M22 12 12 22l-1.43-1.43L18.14 13H2v-2h16.14l-7.57-7.57L12 2l10 10Z',
            },
        },
    ],
    'arrow-right-brand': [
        {
            component: 'path',
            props: {
                d: 'm16.02 18.42-2.484-.54c.216-2.138 1.836-4.126 3.564-4.644H3.6v-2.052h13.5c-1.728-.518-3.348-2.506-3.564-4.644L16.02 6c.108 3.11 1.922 4.946 4.86 5.184v2.052c-2.938.238-4.752 2.074-4.86 5.184Z',
            },
        },
    ],
    'arrow-up': [
        {
            component: 'path',
            props: {
                d: 'm12 2 10 10-1.43 1.43L13 5.86V22h-2V5.86l-7.57 7.57L2 12 12 2Z',
            },
        },
    ],
    'auto-capture-off': [
        {
            component: 'path',
            props: {
                d: 'M22 8V2h-6v2h4v4h2ZM8 4V2H2v6h2V4h4ZM20 16v4h-4v2h6v-6h-2ZM8 20H4v-4H2v6h6v-2Z',
            },
        },
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'm16.809 19.24 1.475-1.35-.734-.802V8.96l-.015-.015v-.019L14.46 5.85H7.254L6.474 5 5 6.351l2.383 2.601.817.896v-.004l5.961 6.506 1.639 1.8h.01l.999 1.09ZM8.884 7.63h4.556V10h2.36v5.178L8.884 7.63Z',
                fillRule: 'evenodd',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M6.465 17.412v.128a.615.615 0 0 0 .61.61h7.23l-1.637-1.8H8.217v-4.84L8.2 11.49v-.01L6.465 9.585v.011l-.015-.016v7.676c0 .052.005.104.015.154Z',
            },
        },
    ],
    'auto-capture-on': [
        {
            component: 'path',
            props: {
                d: 'M22 2v6h-2V4h-4V2h6ZM8 2v2H4v4H2V2h6ZM20 20v-4h2v6h-6v-2h4ZM4 20h4v2H2v-6h2v4Z',
            },
        },
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M7.08 5.85a.612.612 0 0 0-.615.61v11.08a.615.615 0 0 0 .61.61h9.85a.615.615 0 0 0 .61-.62V8.926L14.46 5.85H7.08ZM8.2 7.63h5.24V10h2.36v6.35H8.2V7.63Z',
                fillRule: 'evenodd',
            },
        },
    ],
    'avatar-list': [
        {
            component: 'path',
            props: {
                d: 'M2 22a7.61 7.61 0 0 1 2.237-5.387 7.645 7.645 0 0 1 10.8 0A7.61 7.61 0 0 1 17.272 22h-1.91a5.708 5.708 0 0 0-1.677-4.04 5.734 5.734 0 0 0-8.1 0A5.708 5.708 0 0 0 3.91 22H2Zm7.636-8.571A5.72 5.72 0 0 1 3.91 7.714 5.72 5.72 0 0 1 9.636 2a5.72 5.72 0 0 1 5.728 5.714 5.72 5.72 0 0 1-5.728 5.715Zm0-1.905a3.813 3.813 0 0 0 3.819-3.81 3.813 3.813 0 0 0-3.819-3.81 3.813 3.813 0 0 0-3.818 3.81 3.813 3.813 0 0 0 3.818 3.81ZM17.714 6H22v1.833h-4.286V6ZM16 10.583h6v1.834h-6v-1.834Zm2.571 4.584H22V17h-3.429v-1.833Z',
            },
        },
    ],
    bank: [
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M5 6V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v2h3v2h-1v11h1v2H2v-2h1V8H2V6h3Zm2 0V5h10v1H7ZM5.998 8H5v11h2v-7h2v7h2v-7h2v7h2v-7h2v7h2V8H5.998Z',
                fillRule: 'evenodd',
            },
        },
    ],
    bell: [
        {
            component: 'path',
            props: {
                d: 'M5.57 16.847h13.023v-6.482c0-3.613-2.915-6.54-6.512-6.54-3.596 0-6.511 2.927-6.511 6.54v6.482ZM12.08 1.964c4.624 0 8.372 3.76 8.372 8.4v8.344H3.71v-8.343c0-4.64 3.75-8.401 8.372-8.401ZM9.756 19.638h4.65a2.326 2.326 0 1 1-4.65 0Z',
            },
        },
    ],
    blog: [
        {
            component: 'path',
            props: {
                d: 'M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993ZM11 5H4v14h7V5Zm2 0v14h7V5h-7Zm1 2h5v2h-5V7Zm0 3h5v2h-5v-2Z',
            },
        },
    ],
    book: [
        {
            component: 'path',
            props: {
                d: 'M13 21v1h-2v-1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6a3.99 3.99 0 0 1 3 1.354A3.99 3.99 0 0 1 15 3h6a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-8Zm7-2V5h-5a2 2 0 0 0-2 2v12h7Zm-9 0V7a2 2 0 0 0-2-2H4v14h7Z',
            },
        },
    ],
    'box-none': [
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M3 8.4A5.4 5.4 0 0 1 8.4 3h7.2A5.4 5.4 0 0 1 21 8.4v7.2a5.4 5.4 0 0 1-5.4 5.4H8.4A5.4 5.4 0 0 1 3 15.6V8.4Zm5.4-3.6h7.2a3.6 3.6 0 0 1 3.6 3.6v7.2a3.6 3.6 0 0 1-3.6 3.6H8.4a3.6 3.6 0 0 1-3.6-3.6V8.4a3.6 3.6 0 0 1 3.6-3.6Z',
                fillRule: 'evenodd',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M7 11h10v2H7v-2Z',
            },
        },
    ],
    building: [
        {
            component: 'path',
            props: {
                d: 'M21 19h1v2H2v-2h1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v15h4v-8h-4V9h5a1 1 0 0 1 1 1v9ZM5 5v14h8V5H5Zm2 6h4v2H7v-2Zm0-4h4v2H7V7Z',
            },
        },
    ],
    'bulk-transfer': [
        {
            component: 'path',
            props: {
                d: 'M14 7 9.05 2.05 7.636 3.464 10.172 6H3v2h7.172l-2.536 2.536L9.05 11.95 14 7ZM22 17l-4.95-4.95-1.414 1.414L18.172 16H3v2l15.172-.001-2.536 2.537 1.414 1.414L22 17Z',
            },
        },
    ],
    calendar: [
        {
            component: 'path',
            props: {
                d: 'M17 4h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h4V2h2v2h6V2h2v2Zm-2 2H9v2H7V6H4v4h16V6h-3v2h-2V6Zm5 6H4v8h16v-8Z',
            },
        },
    ],
    'calendar-next': [
        {
            component: 'path',
            props: {
                d: 'M11.086 16.136 12.5 17.55 17.05 13 12.5 8.45l-1.414 1.414L13.222 12H7.05v2h6.172l-2.136 2.136Z',
            },
        },
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M17 4h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h4V2h2v2h6V2h2v2Zm-2 2H9v2H7V6H4v14h16V6h-3v2h-2V6Z',
                fillRule: 'evenodd',
            },
        },
    ],
    camera: [
        {
            component: 'path',
            props: {
                d: 'm9.828 5-2 2H4v12h16V7h-3.828l-2-2H9.828ZM9 3h6l2 2h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4l2-2Zm3 15a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11Zm0-2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z',
            },
        },
    ],
    cancel: [
        {
            component: 'path',
            props: {
                d: 'M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16.001A8 8 0 0 0 12 20Zm0-9.414 2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586Z',
            },
        },
    ],
    'card-recto': [
        {
            component: 'path',
            props: {
                d: 'M3 4h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Zm17 7H4v7h16v-7Zm0 0V6H4v5h16Z',
            },
        },
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M14.224 15.6c.337-.383.542-.884.542-1.434 0-.549-.205-1.05-.542-1.433a2.166 2.166 0 1 1 0 2.866Zm-2.595.72a2.166 2.166 0 1 1-.463-4.308 2.166 2.166 0 0 1 .463 4.309Z',
                fillRule: 'evenodd',
            },
        },
    ],
    'card-verso': [
        {
            component: 'path',
            props: {
                d: 'M3 4h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Zm17 7H4v7h16v-7Zm0-3V6H4v2h16Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M6 13h6v2H6v-2ZM14 13h3v2h-3v-2Z',
            },
        },
    ],
    cash: [
        {
            component: 'path',
            props: {
                d: 'M11.87 8.826a3.66 3.66 0 0 0-3.44-.648 3.631 3.631 0 0 0-1.69 1.15A3.585 3.585 0 0 0 5.95 11.2H5.12v1.6h.83c.077.687.352 1.336.792 1.872.44.536 1.026.935 1.688 1.15a3.659 3.659 0 0 0 3.392-.61l-1.034-1.227a2.026 2.026 0 0 1-2.749-.267 1.994 1.994 0 0 1-.459-.918h2.35v-1.6H7.58c.07-.34.228-.657.459-.918a2.018 2.018 0 0 1 1.887-.65c.334.062.647.207.91.42l1.034-1.227Z',
            },
        },
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M3 5h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm1 12h12V7H4v10Zm16 0h-2V7h2v10Z',
                fillRule: 'evenodd',
            },
        },
    ],
    chart: [
        {
            component: 'path',
            props: {
                d: 'M5.555 9.956h2.5v11h-2.5v-11ZM16 6h2.5v15H16V6ZM10.77 2.927h2.5v18h-2.5v-18Z',
            },
        },
    ],
    chat: [
        {
            component: 'path',
            props: {
                d: 'M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455Zm-.692-2H20V5H4v13.385L5.763 17ZM11 10h2v2h-2v-2Zm-4 0h2v2H7v-2Zm8 0h2v2h-2v-2Z',
            },
        },
    ],
    check: [
        {
            component: 'path',
            props: {
                d: 'M3 5.5h18a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1Zm17 2H4v9h16v-9Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M15 9.5h3v2h-3v-2ZM10 12.5h8v2h-8v-2ZM6 12.5h3v2H6v-2Z',
            },
        },
    ],
    'checkbox-checked': [
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M16 3H8a5 5 0 0 0-5 5v8a5 5 0 0 0 5 5h8a5 5 0 0 0 5-5V8a5 5 0 0 0-5-5Zm-4.997 13L6.76 11.757l1.414-1.414 2.829 2.829 5.656-5.657 1.415 1.414L11.003 16Z',
                fillRule: 'evenodd',
            },
        },
    ],
    'checkbox-unchecked': [
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M16 5H8a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3ZM8 3a5 5 0 0 0-5 5v8a5 5 0 0 0 5 5h8a5 5 0 0 0 5-5V8a5 5 0 0 0-5-5H8Z',
                fillRule: 'evenodd',
            },
        },
    ],
    'chevron-down': [
        {
            component: 'path',
            props: {
                d: 'm11.914 13.14 5.656-5.655L19 8.915 11.915 16 5 9.086l1.43-1.43 5.484 5.485Z',
            },
        },
    ],
    'chevron-left': [
        {
            component: 'path',
            props: {
                d: 'm10.86 11.914 5.655 5.656-1.43 1.43L8 11.915 14.914 5l1.43 1.43-5.485 5.484Z',
            },
        },
    ],
    'chevron-right': [
        {
            component: 'path',
            props: {
                d: 'M16.278 12.258 9.536 5.516 8 7.052l5.206 5.206L8 17.464 9.536 19l6.74-6.74.002-.002Z',
            },
        },
    ],
    'chevron-up': [
        {
            component: 'path',
            props: {
                d: 'M12.086 10.86 6.43 16.514 5 15.085 12.085 8 19 14.914l-1.43 1.43-5.484-5.485Z',
            },
        },
    ],
    'circle-photo': [
        {
            component: 'circle',
            props: { cx: 12, cy: 12, fill: 'none', r: 11, strokeWidth: 2 },
        },
    ],
    clock: [
        {
            component: 'path',
            props: {
                d: 'M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16.001A8 8 0 0 0 12 20Zm1-8h4v2h-6V7h2v5Z',
            },
        },
    ],
    'clock-late': [
        {
            component: 'path',
            props: {
                d: 'M12 2C6.477 2 2 6.477 2 12c0 1.607.379 3.125 1.052 4.47l1.597-.865C4.204 14.536 4 13.32 4 12a8 8 0 1 1 8 8v2c5.523 0 10-4.477 10-10S17.523 2 12 2Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M9 14v5H7v-5h2ZM9 20v2H7v-2h2ZM11 7h2v4h3v2h-5V7Z',
            },
        },
    ],
    clothing: [
        {
            component: 'path',
            props: {
                d: 'M12.998 20H18.998V16H14.998V14H18.998V6H16.998V11L12.998 9.4V20ZM10.998 20V9.4L6.99805 11V6H4.99805V20H10.998ZM6.99805 4V3H16.998V4H19.998C20.5503 4 20.998 4.44772 20.998 5V21C20.998 21.5523 20.5503 22 19.998 22H3.99805C3.44576 22 2.99805 21.5523 2.99805 21V5C2.99805 4.44772 3.44576 4 3.99805 4H6.99805ZM11.998 8L15.498 5H8.49805L11.998 8Z',
            },
        },
    ],
    cloud: [
        {
            component: 'path',
            props: {
                d: 'M16.544 21H7.456a5.504 5.504 0 0 1-3.518-1.264 5.352 5.352 0 0 1-1.86-3.201 5.3 5.3 0 0 1 .675-3.628 5.435 5.435 0 0 1 2.893-2.343 6.178 6.178 0 0 1 .393-2.488c.301-.794.762-1.52 1.357-2.134a6.364 6.364 0 0 1 2.1-1.436 6.446 6.446 0 0 1 5.008 0 6.364 6.364 0 0 1 2.1 1.436 6.25 6.25 0 0 1 1.357 2.134c.3.795.434 1.641.393 2.488a5.435 5.435 0 0 1 2.893 2.343 5.3 5.3 0 0 1 .675 3.628 5.352 5.352 0 0 1-1.86 3.2A5.504 5.504 0 0 1 16.544 21Zm-9.088-1.79h9.088c.493 0 .98-.1 1.434-.293a3.637 3.637 0 0 0 1.2-.826 3.57 3.57 0 0 0 .771-1.226 3.529 3.529 0 0 0-.153-2.82 3.588 3.588 0 0 0-.9-1.138 3.688 3.688 0 0 0-2.74-.837 4.414 4.414 0 0 0-.349-4.25 4.519 4.519 0 0 0-1.642-1.491 4.6 4.6 0 0 0-4.33 0 4.518 4.518 0 0 0-1.642 1.49 4.414 4.414 0 0 0-.35 4.25 3.688 3.688 0 0 0-2.74.838 3.588 3.588 0 0 0-.9 1.137 3.537 3.537 0 0 0 .62 4.047c.338.353.747.634 1.2.826.452.193.94.292 1.433.293Z',
            },
        },
    ],
    'cloud-download': [
        {
            component: 'path',
            props: {
                d: 'M16.524 18.622v-1.828h.457a3.2 3.2 0 0 0 2.949-4.439 3.199 3.199 0 0 0-5.234-1v-.046a5.484 5.484 0 1 0-7.313 5.173v1.91a7.312 7.312 0 1 1 8.645-9.735 5.027 5.027 0 1 1 .953 9.965h-.457Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M11.262 15.501v-3.278h1.828v3.278l1.67-1.672 1.294 1.293L12.176 19l-3.878-3.878 1.293-1.293 1.671 1.672Z',
            },
        },
    ],
    company: [
        {
            component: 'path',
            props: {
                d: 'M2 20h20v2H2v-2Zm2-8h2v7H4v-7Zm7 0h2v7h-2v-7Zm7 0h2v7h-2v-7ZM2 7l10-5 10 5v4H2V7Zm2 1.236V9h16v-.764l-8-4-8 4ZM12 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z',
            },
        },
    ],
    computer: [
        {
            component: 'path',
            props: {
                d: 'M6 7v7h12V7H6Zm-2-.993C4 5.451 4.455 5 4.992 5h14.016c.548 0 .992.449.992 1.007V16H4V6.007ZM2 17h20v2H2v-2Z',
            },
        },
    ],
    contribution: [
        {
            component: 'path',
            props: {
                d: 'M12 22C6.477 22 2 17.523 2 12c0-4.478 2.943-8.268 7-9.542v2.124A8.003 8.003 0 0 0 12 20a8.002 8.002 0 0 0 7.418-5h2.124c-1.274 4.057-5.064 7-9.542 7Zm9.95-9H11V2.05c.329-.033.663-.05 1-.05 5.523 0 10 4.477 10 10 0 .337-.017.671-.05 1ZM13 4.062V11h6.938A8.004 8.004 0 0 0 13 4.062Z',
            },
        },
    ],
    copy: [
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M3 3a1 1 0 0 1 1-1h10v2H5v11H3V3Zm4 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V7Zm2 1v12h10V8H9Z',
                fillRule: 'evenodd',
            },
        },
    ],
    cross: [
        {
            component: 'path',
            props: {
                d: 'M4.43 3 12 10.57 19.57 3 21 4.43 13.43 12 21 19.57 19.57 21 12 13.43 4.43 21 3 19.57 10.57 12 3 4.43 4.43 3Z',
            },
        },
    ],
    'cross-file': [
        {
            component: 'path',
            props: {
                d: 'm12 10.586 2.121-2.122 1.414 1.415L13.415 12l2.12 2.121-1.414 1.415L12 13.414l-2.121 2.122-1.415-1.415L10.586 12 8.464 9.879 9.88 8.464l2.12 2.122Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M3.999 2a.995.995 0 0 0-1 .992v18.016a1 1 0 0 0 .994.992h16.014A1 1 0 0 0 21 20.993V7l-5-5H3.999Zm1 2h10v4h4v12H5V4Z',
            },
        },
    ],
    desktop: [
        {
            component: 'path',
            props: {
                d: 'M4 16h16V5H4v11Zm9 2v2h4v2H7v-2h4v-2H2.992A1 1 0 0 1 2 16.993V4.007C2 3.451 2.455 3 2.992 3h18.016c.548 0 .992.449.992 1.007v12.986c0 .556-.455 1.007-.992 1.007H13Z',
            },
        },
    ],
    'device-line-2': [
        {
            component: 'path',
            props: {
                d: 'M18 8.00002H20C20.2652 8.00002 20.5196 8.10537 20.7071 8.29291C20.8946 8.48044 21 8.7348 21 9.00002V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8947 20.2652 22 20 22H12C11.7348 22 11.4804 21.8947 11.2929 21.7071C11.1054 21.5196 11 21.2652 11 21V20H3C2.73478 20 2.48043 19.8947 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V3.00002C2 2.7348 2.10536 2.48044 2.29289 2.29291C2.48043 2.10537 2.73478 2.00002 3 2.00002H17C17.2652 2.00002 17.5196 2.10537 17.7071 2.29291C17.8946 2.48044 18 2.7348 18 3.00002V8.00002ZM16 8.00002V4.00002H4V18H11V9.00002C11 8.7348 11.1054 8.48044 11.2929 8.29291C11.4804 8.10537 11.7348 8.00002 12 8.00002H16ZM13 10V20H19V10H13Z',
            },
        },
        {
            component: 'circle',
            props: { cx: 15.9937, cy: 18.2499, r: 0.81399 },
        },
    ],
    'direct-debit': [
        {
            component: 'path',
            props: {
                d: 'm11.007 5.828-3.95 3.95-1.414-1.414L12.007 2l6.364 6.364-1.414 1.414-3.95-3.95V17h-2V5.828ZM4 19h16v2H4v-2Z',
            },
        },
    ],
    'doc-check': [
        {
            component: 'path',
            props: {
                d: 'M15 4H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M10.89 14.242 15.133 10l1.414 1.414-5.657 5.657L7 13.181l1.415-1.414 2.475 2.475Z',
            },
        },
    ],
    dot: [
        {
            component: 'path',
            props: {
                d: 'M17 12a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z',
            },
        },
    ],
    'dots-grip': [
        {
            component: 'path',
            props: {
                d: 'M7 18h3v3H7v-3ZM7 4h3v3H7V4ZM7 11h3v3H7v-3ZM14 18h3v3h-3v-3ZM14 4h3v3h-3V4ZM14 11h3v3h-3v-3Z',
            },
        },
    ],
    download: [
        {
            component: 'path',
            props: {
                d: 'M20.032 19.364h-16v-5h-2v6a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-6h-2v5Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'm11.008 13.172-3.95-3.95-1.414 1.414L12.008 17l6.364-6.364-1.415-1.414-3.95 3.95V2h-2v11.172Z',
            },
        },
    ],
    drag: [
        {
            component: 'path',
            props: {
                d: 'M2 8h20v2H2V8ZM2 14h20v2H2v-2Z',
            },
        },
    ],
    duplicate: [
        {
            component: 'path',
            props: {
                d: 'M3 3a1 1 0 0 1 1-1h10v2H5v11H3V3Z',
            },
        },
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M7 7a1 1 0 0 1 1-1h8a1 1 0 0 1 .707.293l4 4A1 1 0 0 1 21 11v10a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V7Zm12 4.5h-3.5V8H9v12h10v-8.5Z',
                fillRule: 'evenodd',
            },
        },
    ],
    earth: [
        {
            component: 'path',
            props: {
                d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93Zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H9a1 1 0 1 1 0-2h1c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39Z',
            },
        },
    ],
    easy: [
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'm8.015 12.917 4.751-6.652c.39.303.763.695.99 1.152.296.59.401 1.387-.27 2.48-.487.795-.009 2.02 1.114 2.02H19v1.8l-2.167 5.2H8v-6h.015Zm-3.015-2h1.985l4.552-6.373a1.286 1.286 0 0 1 1.683-.376c.742.422 1.752 1.204 2.327 2.356.483.97.618 2.128.15 3.393H19.7a1.3 1.3 0 0 1 1.3 1.3v2.9l-2.5 6a1.3 1.3 0 0 1-1.2.8H4a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h1Zm1 8v-6H5v6h1Z',
                fillRule: 'evenodd',
            },
        },
    ],
    edit: [
        {
            component: 'path',
            props: {
                d: 'M6.414 16 16.556 5.858l-1.414-1.414L5 14.586V16h1.414Zm.829 2H3v-4.243L14.435 2.322a1 1 0 0 1 1.414 0l2.829 2.83a1 1 0 0 1 0 1.413L7.243 18ZM3 20h18v2H3v-2Z',
            },
        },
    ],
    'edit-file': [
        {
            component: 'path',
            props: {
                d: 'm21 6.757-2 2V4h-9v5H5v11h14v-2.757l2-2v5.765a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 20.993V8l6.003-6h10.995C20.55 2 21 2.455 21 2.992v3.765Zm.778 2.05 1.414 1.415L15.414 18l-1.416-.002.002-1.412 7.778-7.779Z',
            },
        },
    ],
    'edit-theme': [
        {
            component: 'path',
            props: {
                d: 'M15 4H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'm13.5 11 .945 2.555L17 14.5l-2.555.945L13.5 18l-.945-2.555L10 14.5l2.555-.945L13.5 11ZM9.5 7l.675 1.825L12 9.5l-1.825.675L9.5 12l-.675-1.825L7 9.5l1.825-.675L9.5 7Z',
            },
        },
    ],
    ellipsis: [
        {
            component: 'path',
            props: {
                d: 'M4.056 10.479h3.2v3.2h-3.2v-3.2ZM10.456 10.479h3.2v3.2h-3.2v-3.2ZM16.856 10.479h3.2v3.2h-3.2v-3.2Z',
            },
        },
    ],
    equipment: [
        {
            component: 'path',
            props: {
                d: 'M2 4c0-.552.455-1 .992-1h18.016c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1H2.992A.996.996 0 0 1 2 18V4Zm2 1v12h16V5H4Zm1 15h14v2H5v-2Z',
            },
        },
    ],
    euro: [
        {
            component: 'path',
            props: {
                d: 'M20.804 17.19c-1.51 2.045-3.931 3.348-7.066 3.348-2.024 0-3.758-.506-5.187-1.552-1.432-1.049-2.4-2.42-2.945-4.135l-.022-.07H3.1v-2.127h2.096l-.014-.112a6.974 6.974 0 0 1-.02-.723c0-.33 0-.567.02-.722l.014-.113H3.1V8.857h2.523l.023-.068a8.196 8.196 0 0 1 3.047-4.115c1.472-1.05 3.146-1.574 5.066-1.574 2.73 0 4.745 1.064 6.055 2.615L18.1 7.428c-.935-1.283-2.409-2.078-4.342-2.078-2.386 0-4.422 1.266-5.419 3.364l-.068.143H13.944v2.127H7.69l-.011.088c-.021.17-.021.419-.021.738V11.828c0 .32 0 .569.02.738l.012.088h6.235v2.127H8.173l.064.141c.977 2.163 2.996 3.366 5.501 3.366 1.817 0 3.253-.516 4.337-1.58a7.09 7.09 0 0 0 .767-.886l1.962 1.368Z',
            },
        },
    ],
    expand: [
        {
            component: 'path',
            props: {
                d: 'M16.595 5.91h-5.083V3.69h8.88v8.881h-2.22V7.474l-4.387 4.388-1.57-1.57 4.38-4.38ZM7.489 18.017h5.083v2.22H3.69v-8.88h2.22v5.098l4.388-4.388 1.57 1.57-4.38 4.38Z',
            },
        },
    ],
    'expand-down': [
        {
            component: 'path',
            props: {
                d: 'M3 8V7a1 1 0 0 0-.707 1.707L3 8Zm9 9-.707.707.707.707.707-.707L12 17Zm9-9 .707.707A1 1 0 0 0 21 7v1Zm-18.707.707 9 9 1.414-1.414-9-9-1.414 1.414Zm10.414 9 9-9-1.414-1.414-9 9 1.414 1.414ZM21 7H3v2h18V7Z',
            },
        },
    ],
    export: [
        {
            component: 'path',
            props: {
                d: 'M20.036 19.364h-16v-5h-2v6a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-6h-2v5Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'm12.981 5.828 3.95 3.95 1.414-1.414L11.981 2 5.617 8.364l1.414 1.414 3.95-3.95V17h2V5.828Z',
            },
        },
    ],
    'eye-close': [
        {
            component: 'path',
            props: {
                d: 'M17.882 19.297A10.95 10.95 0 0 1 12 21c-5.392 0-9.878-3.88-10.819-9a10.982 10.982 0 0 1 3.34-6.066L1.392 2.808l1.415-1.415 19.799 19.8-1.415 1.414-3.31-3.31h.001ZM5.935 7.35A8.965 8.965 0 0 0 3.223 12a9.006 9.006 0 0 0 13.201 5.838l-2.028-2.028A4.5 4.5 0 0 1 8.19 9.604L5.935 7.35Zm6.979 6.978-3.242-3.242a2.5 2.5 0 0 0 3.241 3.241l.001.001Zm7.893 2.264-1.431-1.43A8.934 8.934 0 0 0 20.777 12 9.004 9.004 0 0 0 9.552 5.338L7.974 3.76C9.221 3.27 10.58 3 12 3c5.392 0 9.878 3.88 10.819 9a10.947 10.947 0 0 1-2.012 4.592Zm-9.084-9.084a4.5 4.5 0 0 1 4.769 4.77l-4.77-4.77h.001Z',
            },
        },
    ],
    'eye-open': [
        {
            component: 'path',
            props: {
                d: 'M12 3c5.392 0 9.878 3.88 10.819 9-.94 5.12-5.427 9-10.819 9-5.392 0-9.878-3.88-10.819-9C2.121 6.88 6.608 3 12 3Zm0 16a9.005 9.005 0 0 0 8.777-7 9.005 9.005 0 0 0-17.554 0A9.005 9.005 0 0 0 12 19Zm0-2.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm0-2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z',
            },
        },
    ],
    file: [
        {
            component: 'path',
            props: {
                d: 'M15 4H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M7 16h10v2H7v-2ZM7 13h10v2H7v-2ZM7 10h5v2H7v-2Z',
            },
        },
    ],
    filter: [
        {
            component: 'path',
            props: {
                d: 'M2 6h20v2H2V6ZM7 11h10v2H7v-2ZM9 16h6v2H9v-2Z',
            },
        },
    ],
    'filter-new': [
        {
            component: 'path',
            props: {
                d: 'M2 6h20v2H2V6ZM7 11h10v2H7v-2ZM9 16h6v2H9v-2Z',
            },
        },
    ],
    'first-aid-kit': [
        {
            component: 'path',
            props: {
                d: 'M16 2C16.5523 2 17 2.44772 17 3V6H21C21.5523 6 22 6.44772 22 7V21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21V7C2 6.44772 2.44772 6 3 6H7V3C7 2.44772 7.44772 2 8 2H16ZM20 8H4V20H20V8ZM13 10V13H16V15H12.999L13 18H11L10.999 15H8V13H11V10H13ZM15 4H9V6H15V4Z',
            },
        },
    ],
    flash: [
        {
            component: 'path',
            props: {
                d: 'M13 9h8L11 24v-9H4l9-15v9Zm-2 2V7.22L7.532 13H13v4.394L17.263 11H11Z',
            },
        },
    ],
    'flash-auto': [
        {
            component: 'path',
            props: {
                d: 'M9.412 9.5H16L7.765 22v-7.5H2L9.412 2v7.5Zm-1.647 1.667v-3.15l-2.856 4.816h4.503v3.662l3.51-5.328H7.765ZM16.088 8h1.2l.48-1.264h2.672L20.928 8h1.192l-2.248-5.6h-1.528L16.088 8Zm2.056-2.24.96-2.504.968 2.504h-1.928Z',
            },
        },
    ],
    food: [
        {
            component: 'path',
            props: {
                d: 'm14.317 11.478-.938.962 7.764 7.967L19.59 22l-7.763-7.966L4.063 22l-1.552-1.593L12.765 9.884c-.646-1.641.021-4.005 1.778-5.81 2.144-2.2 5.099-2.735 6.6-1.194 1.5 1.54.98 4.572-1.164 6.771-1.759 1.805-4.062 2.49-5.662 1.827ZM3.287 2.083l7.375 7.568-3.105 3.188-4.271-4.383A4.567 4.567 0 0 1 2 5.269c0-1.195.463-2.34 1.286-3.186h.001Zm15.139 5.974c1.38-1.416 1.665-3.072 1.164-3.585-.5-.514-2.113-.222-3.493 1.194-1.38 1.417-1.665 3.072-1.164 3.586.5.513 2.112.221 3.492-1.195Z',
            },
        },
    ],
    forbidden: [
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm8 10a8 8 0 0 1-12.906 6.32L18.32 7.094A7.965 7.965 0 0 1 20 12ZM5.68 16.905 16.906 5.68A8 8 0 0 0 5.68 16.905Z',
                fillRule: 'evenodd',
            },
        },
    ],
    frown: [
        {
            component: 'path',
            props: {
                d: 'M11.72 2c5.25-.11 9.83 4.47 9.72 9.72.11 5.25-4.47 9.83-9.72 9.72-5.25.11-9.83-4.47-9.72-9.72C1.89 6.47 6.47 1.89 11.72 2Zm0 1.97c-4.19-.08-7.83 3.55-7.75 7.75-.08 4.19 3.55 7.83 7.75 7.75 4.19.08 7.83-3.55 7.75-7.75.08-4.19-3.55-7.83-7.75-7.75ZM6.61 15.42c.67-2.11 2.67-3.69 5.11-3.69 2.44 0 4.44 1.58 5.11 3.69l-1.81.78c-.47-1.56-1.67-2.5-3.31-2.5-1.64 0-2.83.94-3.31 2.5l-1.8-.78h.01ZM8.8 7.48c.75 0 1.33.58 1.33 1.33 0 .75-.58 1.33-1.33 1.33-.75 0-1.33-.58-1.33-1.33 0-.75.58-1.33 1.33-1.33Zm5.83 0c.75 0 1.33.58 1.33 1.33 0 .75-.58 1.33-1.33 1.33-.75 0-1.33-.58-1.33-1.33 0-.75.58-1.33 1.33-1.33Z',
            },
        },
    ],
    gift: [
        {
            component: 'path',
            props: {
                d: 'M14.727 4c.639 0 1.266.165 1.819.48a3.608 3.608 0 0 1 1.331 1.31 3.536 3.536 0 0 1 0 3.58L22 9.367v1.79h-1.818v8.947a.888.888 0 0 1-.266.633.917.917 0 0 1-.643.262H4.727a.917.917 0 0 1-.643-.262.887.887 0 0 1-.266-.633v-8.947H2v-1.79l4.124.001a3.53 3.53 0 0 1-.406-2.542c.19-.868.7-1.636 1.432-2.154a3.68 3.68 0 0 1 4.85.54c.34-.382.76-.688 1.23-.897.47-.21.981-.317 1.497-.316Zm-3.636 7.158H5.636v8.053h5.455v-8.053Zm7.273 0h-5.455v8.053h5.455v-8.053ZM9.273 5.789a1.834 1.834 0 0 0-1.267.498 1.773 1.773 0 0 0-.095 2.487 1.83 1.83 0 0 0 1.225.59l.137.004h1.818v-1.79c0-.427-.156-.84-.439-1.165a1.826 1.826 0 0 0-1.104-.603l-.14-.016-.135-.005Zm5.454 0c-.458 0-.9.17-1.237.478a1.779 1.779 0 0 0-.576 1.178l-.005.134v1.79h1.818c.459 0 .9-.17 1.237-.478.336-.307.542-.728.577-1.178l.005-.134c0-.475-.192-.93-.533-1.265a1.833 1.833 0 0 0-1.286-.525Z',
            },
        },
    ],
    heart: [
        {
            component: 'path',
            props: {
                d: 'M12.001 4.529a5.998 5.998 0 0 1 8.242.228 6 6 0 0 1 .236 8.236l-8.48 8.492-8.478-8.492a6 6 0 0 1 8.48-8.464Zm6.826 1.641a3.998 3.998 0 0 0-5.49-.153l-1.335 1.198-1.336-1.197a3.999 3.999 0 0 0-5.494.154 4 4 0 0 0-.192 5.451L12 18.654l7.02-7.03a4 4 0 0 0-.193-5.454Z',
            },
        },
    ],
    'heart-broken': [
        {
            component: 'path',
            props: {
                d: 'M12.001 4.529a5.998 5.998 0 0 1 8.242.228 6 6 0 0 1 .236 8.236l-8.48 8.492-8.478-8.492a6 6 0 0 1 8.48-8.464Zm6.826 1.641a3.998 3.998 0 0 0-5.49-.153l-1.335 1.198-1.336-1.197a3.999 3.999 0 0 0-5.494.154 4 4 0 0 0-.192 5.451L12 18.654l7.02-7.03a4 4 0 0 0-.193-5.454Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M11.08 9.163a1 1 0 0 0 .175 1.178l2.078 2.078a3 3 0 0 1 .725 3.07l-1.218 3.655h-.109l-1.789-.633 1.219-3.655a1 1 0 0 0-.242-1.023L9.84 11.755a3 3 0 0 1-.526-3.533l1.651-3.096 1.765.94-1.651 3.097Z',
            },
        },
    ],
    'heart-hand': [
        {
            component: 'path',
            props: {
                d: 'M3.16104 4.46868C4.3211 3.3084 5.87704 2.62976 7.51664 2.56892C9.15624 2.5081 10.7582 3.06956 12.001 4.14068C13.2428 3.07134 14.8426 2.5105 16.4803 2.57044C18.1179 2.63036 19.6724 3.30664 20.8328 4.46388C21.993 5.62112 22.6734 7.1739 22.7376 8.81136C22.8018 10.4488 22.2452 12.0501 21.179 13.2947L13.414 21.0846C13.0573 21.4416 12.5788 21.6504 12.0746 21.6694C11.5703 21.6882 11.0775 21.5158 10.695 21.1866L10.585 21.0856L2.82104 13.2947C1.75553 12.0512 1.19862 10.4514 1.26166 8.81506C1.32469 7.17874 2.00302 5.6265 3.16104 4.46868ZM4.57504 5.88268C3.75728 6.70066 3.2859 7.80212 3.25872 8.95844C3.23152 10.1148 3.65062 11.2372 4.42904 12.0927L4.57504 12.2467L12 19.6717L17.303 14.3677L13.768 10.8327L12.708 11.8927C12.4295 12.1713 12.0988 12.3924 11.7348 12.5433C11.3709 12.6941 10.9807 12.7718 10.5868 12.7719C9.79104 12.7721 9.02784 12.4562 8.46504 11.8937C7.90226 11.3312 7.58598 10.5681 7.58578 9.77238C7.5856 8.97666 7.90152 8.21346 8.46404 7.65068L10.566 5.54768C9.72952 4.88006 8.68246 4.53236 7.61272 4.567C6.543 4.60164 5.52064 5.01634 4.72904 5.73668L4.57504 5.88268ZM13.061 8.71068C13.2486 8.5232 13.5029 8.4179 13.768 8.4179C14.0332 8.4179 14.2875 8.5232 14.475 8.71068L18.717 12.9527L19.425 12.2467C20.2564 11.4158 20.7298 10.2926 20.7438 9.11724C20.7578 7.94188 20.3114 6.8077 19.5001 5.95724C18.6887 5.10676 17.5767 4.60754 16.402 4.56632C15.2273 4.52512 14.0831 4.94518 13.214 5.73668L13.061 5.88268L9.87904 9.06468C9.70572 9.2379 9.60202 9.46872 9.58764 9.71334C9.57326 9.95796 9.6492 10.1993 9.80104 10.3917L9.87904 10.4787C10.0523 10.652 10.2831 10.7557 10.5277 10.7701C10.7723 10.7845 11.0137 10.7085 11.206 10.5567L11.293 10.4787L13.061 8.71068Z',
            },
        },
    ],
    help: [
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm0-2c1.848 0 3.55-.627 4.905-1.68l-2.148-2.148a4.977 4.977 0 0 1-2.758.828 4.977 4.977 0 0 1-2.757-.828L7.094 18.32A7.966 7.966 0 0 0 12 20Zm8-8a7.965 7.965 0 0 1-1.68 4.906l-2.149-2.149c.524-.79.828-1.738.828-2.757 0-1.019-.305-1.967-.828-2.757l2.149-2.149A7.965 7.965 0 0 1 20 12Zm-8-8c1.848 0 3.55.627 4.905 1.68l-2.148 2.149A4.976 4.976 0 0 0 11.999 7a4.977 4.977 0 0 0-2.757.829L7.094 5.68A7.965 7.965 0 0 1 12 4ZM7.828 9.243 5.68 7.095A7.965 7.965 0 0 0 4 12c0 1.849.627 3.551 1.68 4.906l2.148-2.148A4.977 4.977 0 0 1 6.999 12c0-1.019.305-1.967.829-2.757Zm2.022.665A2.99 2.99 0 0 0 9 12c0 .81.32 1.545.842 2.085l.073.073a2.99 2.99 0 0 0 2.848.744A3.001 3.001 0 1 0 9.907 9.85l-.057.058Z',
                fillRule: 'evenodd',
            },
        },
    ],
    history: [
        {
            component: 'path',
            props: {
                d: 'M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12h2a8 8 0 1 0 1.385-4.5H8v2H2v-6h2V6a9.98 9.98 0 0 1 8-4Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M11 7h2v4h3v2h-5V7Z',
            },
        },
    ],
    home: [
        {
            component: 'path',
            props: {
                d: 'M18.857 19V9.799l-7-5.522-7 5.522V19h14Zm2 1a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V9.314a1 1 0 0 1 .38-.785l8-6.311a1 1 0 0 1 1.24 0l8 6.31a1 1 0 0 1 .38.786V20Zm-14-8h2a3 3 0 1 0 6 0h2a5 5 0 0 1-10 0Z',
            },
        },
    ],
    hotel: [
        {
            component: 'path',
            props: {
                d: 'M21.967 10.934v9h-2v-4h-16v4h-2v-16h2v10h8v-7h6a4 4 0 0 1 4 4Zm-2 3v-3a2 2 0 0 0-2-2h-4v5h6Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M10.498 9.613a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z',
            },
        },
    ],
    hourglass: [
        {
            component: 'path',
            props: {
                d: 'M4.076 4.617A1 1 0 0 1 5 4h14a1 1 0 0 1 .707 1.707L13.414 12l6.293 6.293A1 1 0 0 1 19 20H5a1 1 0 0 1-.707-1.707L10.586 12 4.293 5.707a1 1 0 0 1-.217-1.09ZM12 10.586 16.586 6H7.414L12 10.586Zm0 2.828L7.414 18h9.172L12 13.414Z',
            },
        },
    ],
    independant: [
        {
            component: 'path',
            props: {
                d: 'M13 19h6V9.978l-7-5.444-7 5.444V19h6v-4h2v4Zm8 1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.49a1 1 0 0 1 .386-.79l8-6.222a1 1 0 0 1 1.228 0l8 6.222a1 1 0 0 1 .386.79V20Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M17 4h2v4h-2z',
            },
        },
    ],
    infini: [
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M6.72 7a4.092 4.092 0 0 1 1.68.365 4.1 4.1 0 0 1 1.196.796l.09.075c.327.274.415.348.814.764.07.073.24.276.41.479l.254.304.832.91.446-.48 1.076-1.157.109-.117c.212-.228.424-.456.646-.674a4.392 4.392 0 0 1 1.387-.93c.383-.16.78-.256 1.19-.298a4.67 4.67 0 0 1 1.05.013c.418.051.821.164 1.211.334.5.22.95.522 1.35.91a4.998 4.998 0 0 1 1.42 2.656c.022.12.036.24.05.362.011.092.022.183.036.274.074.471.016.935-.077 1.393a5.675 5.675 0 0 1-.74 1.904 4.302 4.302 0 0 1-1.634 1.531 5.032 5.032 0 0 1-1.37.493c-.462.096-.929.12-1.4.06-.885-.112-1.654-.505-2.333-1.11l-.113-.099c-.177-.157-.342-.301-.543-.512-.21-.22-.36-.374-.476-.492l-.047-.048 1.167-1.267c.122.118.307.291.599.561.333.307.494.443.775.643.525.371 1.096.545 1.724.49a2.986 2.986 0 0 0 1.718-.707c.367-.312.625-.712.802-1.174.163-.422.26-.86.25-1.32a3.212 3.212 0 0 0-.738-2.012 2.845 2.845 0 0 0-2.378-1.053c-.777.038-1.404.41-1.943.994-.532.577-1.069 1.15-1.605 1.723a506.974 506.974 0 0 0-1.912 2.05c-.615.661-1.23 1.323-1.847 1.98A4.458 4.458 0 0 1 7.25 16.95a4.157 4.157 0 0 1-1.21.001c-1.07-.16-1.987-.65-2.74-1.486a4.95 4.95 0 0 1-.915-1.476 5.165 5.165 0 0 1-.321-1.163 5.371 5.371 0 0 1 .45-3.116 4.852 4.852 0 0 1 1.118-1.524 4.35 4.35 0 0 1 1.23-.797 4.798 4.798 0 0 1 1.711-.38l.147-.01Zm4.047 5.013L9.606 10.74c-.262-.283-.523-.566-.787-.847-.266-.282-.553-.536-.89-.718a2.575 2.575 0 0 0-1.02-.313 2.715 2.715 0 0 0-.944.092c-.519.142-.987.388-1.375.794a3.007 3.007 0 0 0-.644 1.063 3.394 3.394 0 0 0-.216.976c-.05.89.208 1.668.765 2.33.33.393.728.674 1.192.844.455.168.924.214 1.402.143a2.652 2.652 0 0 0 1.53-.801c.322-.33.637-.669.951-1.007l.343-.368.854-.915Z',
                fillRule: 'evenodd',
            },
        },
    ],
    information: [
        {
            component: 'path',
            props: {
                d: 'M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16.001A8 8 0 0 0 12 20ZM11 7h2v2h-2V7Zm0 4h2v6h-2v-6Z',
            },
        },
    ],
    insurance: [
        {
            component: 'path',
            props: {
                d: 'M11.1 2.955C6.552 3.41 3 7.286 3 12v.91h8.1v5.454c0 .482-.19.944-.527 1.285a1.79 1.79 0 0 1-2.546 0 1.828 1.828 0 0 1-.527-1.285v-.91H5.7v.91c0 .964.38 1.889 1.054 2.57A3.582 3.582 0 0 0 9.3 22c.955 0 1.87-.383 2.546-1.065a3.655 3.655 0 0 0 1.054-2.571v-5.455H21V12c0-4.714-3.552-8.59-8.1-9.045v-.046a.914.914 0 0 0-.264-.643.895.895 0 0 0-1.272 0 .914.914 0 0 0-.264.643v.046ZM4.856 11.09a7.296 7.296 0 0 1 2.382-4.545A7.16 7.16 0 0 1 12 4.728a7.16 7.16 0 0 1 4.762 1.818 7.297 7.297 0 0 1 2.382 4.545H4.856Z',
            },
        },
    ],
    invoice: [
        {
            component: 'path',
            props: {
                d: 'M15 4H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M7 13h10v2H7v-2ZM12 16h5v2h-5v-2ZM10 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z',
            },
        },
    ],
    keyboard: [
        {
            component: 'path',
            props: {
                d: 'M9 13h6v2H9v-2ZM5 13h2v2H5v-2ZM17 13h2v2h-2v-2ZM9 9h2v2H9V9ZM17 9h2v2h-2V9ZM13 9h2v2h-2V9ZM5 9h2v2H5V9Z',
            },
        },
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M4 7v10h16V7H4ZM3 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H3Z',
                fillRule: 'evenodd',
            },
        },
    ],
    laptop: [
        {
            component: 'path',
            props: {
                d: 'M4.8 5.867v10.266h14.4V5.867H4.8ZM3 4.94c0-.52.41-.94.893-.94h16.214c.493 0 .893.42.893.94V18H3V4.94ZM23 19H1v2h22v-2Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M23 19H1v2h22v-2Z',
            },
        },
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M5 5v10h14V5H5ZM4 3a1 1 0 0 0-1 1v13h18V4a1 1 0 0 0-1-1H4Z',
                fillRule: 'evenodd',
            },
        },
    ],
    legal: [
        {
            component: 'path',
            props: {
                d: 'M13.26 20.123V22H2v-1.877h11.26ZM13.81 2l7.299 7.299-1.327 1.328-.995-.332-2.324 2.322 5.308 5.308-1.327 1.327-5.307-5.309L12.88 16.2l.266 1.062-1.328 1.327L4.52 11.29l1.328-1.327 1.06.264 5.907-5.905-.332-.994L13.81 2Zm.663 3.318-6.635 6.634 3.317 3.318 6.636-6.634-3.318-3.318Z',
            },
        },
    ],
    less: [
        {
            component: 'path',
            props: {
                d: 'M2 11h20v2H2v-2Z',
            },
        },
    ],
    link: [
        {
            component: 'path',
            props: {
                d: 'M10 3v2H5v14h14v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6Zm7.586 2H13V3h8v8h-2V6.414l-7 7L10.586 12l7-7Z',
            },
        },
    ],
    list: [
        {
            component: 'path',
            props: {
                d: 'M3 18h2v2H3v-2ZM3 4h2v2H3V4ZM3 11h2v2H3v-2ZM8 18h13v2H8v-2ZM8 4h13v2H8V4ZM8 11h13v2H8v-2Z',
            },
        },
    ],
    loader: [
        {
            component: 'path',
            props: {
                d: 'M12 3v2a7 7 0 1 0 4.95 2.05l1.414-1.414A9 9 0 1 1 12 3Z',
            },
        },
    ],
    loan: [
        {
            component: 'path',
            props: {
                d: 'M13 8h8v2h-8V8ZM13 4h8v2h-8V4Z',
            },
        },
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M5.15 10.52V9H3v11.829h2.15v-1.077C6.85 20.551 8.884 21 11.237 21c4.129 0 7.786-1.937 10.045-4.918a4.777 4.777 0 0 0-4.313-2.724H13.96a4.286 4.286 0 0 0-3.202-1.432H8.686a6.657 6.657 0 0 0-3.535-1.407Zm0 1.92v5.152c1.632.973 3.674 1.498 6.086 1.498 2.87 0 5.54-1.105 7.484-2.99l.127-.127-.114-.096a2.859 2.859 0 0 0-1.57-.602l-.195-.006-2.018-.001c.07.307.107.627.107.956v.955H7.301v-1.91l5.645-.001-.032-.075a2.388 2.388 0 0 0-1.999-1.352l-.156-.005H7.96a4.762 4.762 0 0 0-2.81-1.395Z',
                fillRule: 'evenodd',
            },
        },
    ],
    location: [
        {
            component: 'path',
            props: {
                d: 'm12.041 22.06-5.857-5.857a8.284 8.284 0 1 1 11.715 0l-5.858 5.858Zm4.557-7.159a6.444 6.444 0 1 0-9.113 0l4.556 4.557 4.557-4.557Zm-4.556-2.715a1.84 1.84 0 1 1 0-3.681 1.84 1.84 0 0 1 0 3.68Z',
            },
        },
    ],
    lock: [
        {
            component: 'path',
            props: {
                d: 'M19 10h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h1V9a7 7 0 0 1 14 0v1ZM5 12v8h14v-8H5Zm6 2h2v4h-2v-4Zm6-4V9A5 5 0 0 0 7 9v1h10Z',
            },
        },
    ],
    'lock-check': [
        {
            component: 'path',
            props: {
                d: 'M11.34 16.642 14.983 13l1.214 1.214-4.857 4.857L8 15.731l1.215-1.214 2.125 2.125Z',
            },
        },
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M20 10h-1V9A7.002 7.002 0 0 0 7.05 4.05 7 7 0 0 0 5 9v1H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1ZM5 20v-8h14v8H5ZM17 9v1H7V9a5 5 0 1 1 10 0Z',
                fillRule: 'evenodd',
            },
        },
    ],
    login: [
        {
            component: 'path',
            props: {
                d: 'M20 4.015v16h-5v2h6a1 1 0 0 0 1-1v-18a1 1 0 0 0-1-1h-6v2h5Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'm13.172 13.04-3.95 3.95 1.414 1.414L17 12.04l-6.364-6.364L9.222 7.09l3.95 3.95H2v2h11.172Z',
            },
        },
    ],
    'logout-left': [
        {
            component: 'path',
            props: {
                d: 'M20 4.015v16h-5v2h6a1 1 0 0 0 1-1v-18a1 1 0 0 0-1-1h-6v2h5Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'm5.828 11.07 3.95-3.95-1.414-1.415L2 12.07l6.364 6.364 1.414-1.414-3.95-3.95H17v-2H5.828Z',
            },
        },
    ],
    'logout-right': [
        {
            component: 'path',
            props: {
                d: 'M4 19.985v-16h5v-2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h6v-2H4Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'm18.172 13.04-3.95 3.95 1.414 1.414L22 12.04l-6.364-6.364-1.414 1.414 3.95 3.95H7v2h11.172Z',
            },
        },
    ],
    mail: [
        {
            component: 'path',
            props: {
                d: 'M3 4h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Zm17 4.238-7.928 7.1L4 8.216V18h16V8.238ZM4.511 6l7.55 6.662L19.502 6H4.511Z',
            },
        },
    ],
    maintenance: [
        {
            component: 'path',
            props: {
                d: 'M4.69 2.235A4.05 4.05 0 0 1 9.61 7.976L22 20.364 20.364 22 7.974 9.612a4.051 4.051 0 0 1-5.74-4.922l2.588 2.588a1.735 1.735 0 1 0 2.453-2.454L4.69 2.234v.001Zm11.993 2.18 3.681-2.045L22 4.005l-2.045 3.68-2.046.41-2.452 2.454-1.637-1.636 2.453-2.453.41-2.045Zm-5.819 7.453 1.636 1.636-8.088 8.086a1.157 1.157 0 0 1-1.726-1.534l.09-.101 8.088-8.087Z',
            },
        },
    ],
    misc: [
        {
            component: 'path',
            props: {
                d: 'M4 5v14h16V7h-8.414l-2-2H4Zm8.414 0H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M11 15h7v2h-7v-2Z',
            },
        },
    ],
    mobile: [
        {
            component: 'path',
            props: {
                d: 'M7 4v16h10V4H7ZM6 2h12a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm6 15a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z',
            },
        },
    ],
    more: [
        {
            component: 'path',
            props: {
                d: 'M3 3h8v8H3V3Zm0 10h8v8H3v-8ZM13 3h8v8h-8V3Zm0 10h8v8h-8v-8Zm2-8v4h4V5h-4Zm0 10v4h4v-4h-4ZM5 5v4h4V5H5Zm0 10v4h4v-4H5Z',
            },
        },
    ],
    'move-folder': [
        {
            component: 'path',
            props: {
                d: 'M12 2 7 6.95l1.428 1.414 2.562-2.536V11h2.02V5.828l2.562 2.536L17 6.95 12 2ZM20 22v-5h-8.414l-2-2H4v7H2v-8a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1v6h-2Z',
            },
        },
    ],
    music: [
        {
            component: 'path',
            props: {
                d: 'M21 3v14a4 4 0 1 1-2-3.465V5h-9v12a4 4 0 1 1-2-3.465V3h13ZM6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm11 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
            },
        },
    ],
    'nav-close': [
        {
            component: 'path',
            props: {
                d: 'M12 10.57 20.57 2 22 3.43 13.43 12 22 20.57 20.57 22 12 13.43 3.43 22 2 20.57 10.57 12 2 3.43 3.43 2 12 10.57Z',
            },
        },
    ],
    'no-flash': [
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M21 9h-8V0L8.176 8.04 4.475 4 3 5.351l14.815 16.17 1.475-1.35-3.32-3.625L21 9Zm-6.422 6.027L17.263 11H11V7.22L9.585 9.578l4.993 5.45Z',
                fillRule: 'evenodd',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M13.684 19.973 11 17.043V24l2.684-4.027ZM6.03 11.618 9.127 15H4l2.03-3.382Z',
            },
        },
    ],
    'paper-clip': [
        {
            component: 'path',
            props: {
                d: 'M14 13.5V8a4 4 0 1 0-8 0v5.5a6.5 6.5 0 0 0 13 0V4h2v9.5a8.5 8.5 0 1 1-17 0V8a6 6 0 1 1 12 0v5.5a3.5 3.5 0 1 1-7 0V8h2v5.5a1.5 1.5 0 1 0 3 0Z',
            },
        },
    ],
    payment: [
        {
            component: 'path',
            props: {
                d: 'M16.05 12.05 21 17l-4.95 4.95-1.414-1.414 2.536-2.537L4 18v-2h13.172l-2.536-2.536 1.414-1.414Zm-8.1-10 1.414 1.414L6.828 6H20v2H6.828l2.536 2.536L7.95 11.95 3 7l4.95-4.95Z',
            },
        },
    ],
    pdf: [
        {
            component: 'path',
            props: {
                d: 'M15 4H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M6.952 13.617h1.04c.916 0 1.398-.637 1.398-1.315 0-.701-.47-1.302-1.398-1.302H6v4.163h.952v-1.546Zm0-.863v-.892h.98c.31 0 .506.16.506.446 0 .286-.196.446-.505.446h-.981ZM10.174 15.163h1.665c1.374 0 2.2-.85 2.2-2.052 0-1.284-.82-2.111-2.23-2.111h-1.635v4.163Zm.952-3.3h.654c.874 0 1.308.457 1.308 1.248 0 .72-.422 1.19-1.278 1.19h-.684v-2.439ZM14.824 11v4.163h.952v-1.606h2.046v-.862h-2.046v-.833H18V11h-3.176Z',
            },
        },
    ],
    percentage: [
        {
            component: 'path',
            props: {
                d: 'm19.071 3.515 1.414 1.414L4.93 20.485 3.516 19.07 19.071 3.515Z',
            },
        },
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M7.024 10.524a3.502 3.502 0 0 1-3.233-4.839 3.5 3.5 0 1 1 3.233 4.84Zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM17.095 20.595a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z',
                fillRule: 'evenodd',
            },
        },
    ],
    personal: [
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M12 14.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-1.8a2.7 2.7 0 1 0 0-5.4 2.7 2.7 0 0 0 0 5.4Z',
                fillRule: 'evenodd',
            },
        },
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M20 22V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v18h1.88A6.2 6.2 0 0 1 12 16.8a6.202 6.202 0 0 1 6.12 5.2H20ZM18 3.8H6a.2.2 0 0 0-.2.2v13.944A7.984 7.984 0 0 1 12 15c2.5 0 4.733 1.147 6.2 2.944V4a.2.2 0 0 0-.2-.2Z',
                fillRule: 'evenodd',
            },
        },
    ],
    phone: [
        {
            component: 'path',
            props: {
                d: 'M10.366 10.682a10.555 10.555 0 0 0 3.952 3.952l.884-1.238a1 1 0 0 1 1.294-.296 11.422 11.422 0 0 0 4.583 1.364 1 1 0 0 1 .921.997v4.462a1 1 0 0 1-.898.995A15.51 15.51 0 0 1 19.5 21C10.94 21 4 14.06 4 5.5c0-.538.027-1.072.082-1.602A1 1 0 0 1 5.077 3h4.462a1 1 0 0 1 .997.921A11.422 11.422 0 0 0 11.9 8.504a1 1 0 0 1-.296 1.294l-1.238.884Zm-2.522-.657 1.9-1.357A13.41 13.41 0 0 1 8.647 5H6.01c-.006.166-.009.333-.009.5C6 12.956 12.044 19 19.5 19c.167 0 .334-.003.5-.01v-2.637a13.413 13.413 0 0 1-3.668-1.097l-1.357 1.9a12.445 12.445 0 0 1-1.588-.75l-.058-.033a12.556 12.556 0 0 1-4.702-4.702l-.033-.058a12.444 12.444 0 0 1-.75-1.588Z',
            },
        },
    ],
    'phone-offline': [
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M18.44 4.146a.5.5 0 0 1 .706 0l.708.708a.5.5 0 0 1 0 .707l-8.038 8.037c.468.386.97.733 1.502 1.036l.884-1.238a1 1 0 0 1 1.294-.296 11.422 11.422 0 0 0 4.583 1.364 1 1 0 0 1 .921.997v4.462a1 1 0 0 1-.898.995A15.51 15.51 0 0 1 18.5 21c-3.92 0-7.5-1.456-10.23-3.856l-3.71 3.71a.5.5 0 0 1-.706 0l-.708-.707a.5.5 0 0 1 0-.708L18.44 4.146ZM9.686 15.727A13.447 13.447 0 0 0 19 18.99v-2.637a13.413 13.413 0 0 1-3.668-1.097l-1.357 1.9a12.445 12.445 0 0 1-1.588-.75l-.058-.033a12.553 12.553 0 0 1-1.933-1.355l-.709.709Z',
                fillRule: 'evenodd',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M7.627 11.671c.055.097.112.194.17.29l3.2-3.201a1 1 0 0 0-.097-.256 11.422 11.422 0 0 1-1.364-4.583A1 1 0 0 0 8.539 3H4.077a1 1 0 0 0-.995.898A15.51 15.51 0 0 0 3 5.5c0 3.196.967 6.165 2.625 8.633l1.445-1.446A13.435 13.435 0 0 1 5.01 5h2.637a13.41 13.41 0 0 0 1.097 3.668l-1.9 1.357c.212.546.463 1.077.75 1.588l.033.058Z',
            },
        },
    ],
    'phone-screen': [
        {
            component: 'path',
            props: {
                d: 'M7 4v16h10V4H7ZM6 2h12a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm6 15a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'm12.6 9.755-3-2.75 3.5-4.125h1.5l-3.5 4.125 3 2.75-3 4.125H9.6l3-4.125Z',
            },
        },
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M12.984 2.63h2.156l-3.694 4.353 2.823 2.588a.25.25 0 0 1 .033.331l-3.075 4.228H9.11l3.158-4.342L9.43 7.19a.25.25 0 0 1-.022-.346l3.575-4.213Zm.232.5-3.27 3.853 2.823 2.588a.25.25 0 0 1 .033.331l-2.711 3.728h.882l2.793-3.842-2.835-2.599a.25.25 0 0 1-.022-.346L14.06 3.13h-.844Z',
                fillRule: 'evenodd',
            },
        },
    ],
    picture: [
        {
            component: 'path',
            props: {
                d: 'm5 11.1 2-2 5.5 5.5 3.5-3.5 3 3V5H5v6.1Zm0 2.829V19h3.1l2.986-2.985L7 11.929l-2 2ZM10.929 19H19v-2.071l-3-3L10.929 19ZM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm11.5 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z',
            },
        },
    ],
    plane: [
        {
            component: 'path',
            props: {
                d: 'M10.478 11.632 5.968 4.56l1.931-.518 6.951 6.42 5.262-1.41a1.5 1.5 0 1 1 .776 2.898L5.916 15.96l-.776-2.898.241-.065 2.467 2.445-2.626.704a1 1 0 0 1-1.133-.48L1.466 10.94l1.449-.388 2.466 2.445 5.097-1.366v.001ZM4 19h16v2H4v-2Z',
            },
        },
    ],
    plant: [
        {
            component: 'path',
            props: {
                d: 'M6 2a7 7 0 0 1 6.197 3.741A6.49 6.49 0 0 1 17.5 3H21v2.5a6.5 6.5 0 0 1-6.5 6.5H13v1h5v7a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-7h5v-2H9a7 7 0 0 1-7-7V2h4Zm10 13H8v5h8v-5Zm3-10h-1.5A4.5 4.5 0 0 0 13 9.5v.5h1.5A4.5 4.5 0 0 0 19 5.5V5ZM6 4H4a5 5 0 0 0 5 5h2a5 5 0 0 0-5-5Z',
            },
        },
    ],
    plus: [
        {
            component: 'path',
            props: {
                d: 'M11 2h2v20h-2V2Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M22 11v2H2v-2h20Z',
            },
        },
    ],
    profile: [
        {
            component: 'path',
            props: {
                d: 'M4.38 22a7.62 7.62 0 0 1 15.238 0h-1.905a5.714 5.714 0 1 0-11.428 0H4.38ZM12 13.429a5.713 5.713 0 0 1-5.715-5.715A5.713 5.713 0 0 1 11.999 2a5.713 5.713 0 0 1 5.714 5.714A5.713 5.713 0 0 1 12 13.43Zm0-1.905a3.808 3.808 0 0 0 3.809-3.81 3.808 3.808 0 0 0-3.81-3.81 3.808 3.808 0 0 0-3.81 3.81 3.808 3.808 0 0 0 3.81 3.81Z',
            },
        },
    ],
    question: [
        {
            component: 'path',
            props: {
                d: 'M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16.001A8 8 0 0 0 12 20Zm-1-5h2v2h-2v-2Zm2-1.645V14h-2v-1.5a1 1 0 0 1 1-1 1.5 1.5 0 1 0-1.471-1.794l-1.962-.393A3.5 3.5 0 1 1 13 13.355Z',
            },
        },
    ],
    'quotation-mark': [
        {
            component: 'path',
            props: {
                d: 'M6.974 13.535a3.768 3.768 0 1 0-3.639-4.75c-.827 2.766-.018 5.17 1.28 6.996 1.318 1.853 3.17 3.17 4.493 3.83l.926-1.85c-1.091-.546-2.653-1.661-3.732-3.18a7.273 7.273 0 0 1-.756-1.326c.44.18.922.28 1.428.28ZM17.232 13.535a3.768 3.768 0 1 0-3.64-4.742c-.824 2.763-.015 5.164 1.282 6.988 1.317 1.853 3.17 3.17 4.493 3.83l.926-1.85c-1.092-.546-2.653-1.661-3.733-3.18a7.284 7.284 0 0 1-.755-1.325c.44.18.922.28 1.427.28Z',
            },
        },
    ],
    'radio-checked': [
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M12 20.182a8.182 8.182 0 1 0 0-16.364 8.182 8.182 0 0 0 0 16.364ZM12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z',
                fillRule: 'evenodd',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M18.364 12a6.364 6.364 0 1 1-12.728 0 6.364 6.364 0 0 1 12.728 0Z',
            },
        },
    ],
    'radio-unchecked': [
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z',
                fillRule: 'evenodd',
            },
        },
    ],
    receipt: [
        {
            component: 'path',
            props: {
                d: 'M19 22H5a3 3 0 0 1-3-3V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v12h4v4a3 3 0 0 1-3 3Zm-1-5v2a1 1 0 0 0 2 0v-2h-2Zm-2 3V4H4v15a1 1 0 0 0 1 1h11ZM6 8h8v2H6V8Zm0 3h8v2H6v-2Zm0 3h5v2H6v-2Z',
            },
        },
    ],
    'reduced-left': [
        {
            component: 'path',
            props: {
                d: 'm11.735 12 4.354 4.354 1.265-1.265L14.264 12l3.09-3.089-1.265-1.265L11.735 12Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'm6.735 12 4.354 4.354 1.264-1.265L9.265 12l3.088-3.089-1.264-1.265L6.735 12Z',
            },
        },
    ],
    'reduced-right': [
        {
            component: 'path',
            props: {
                d: 'M12.265 12 7.91 7.646 6.646 8.911 9.736 12l-3.09 3.089 1.265 1.265L12.265 12Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M17.265 12 12.91 7.646l-1.264 1.265L14.735 12l-3.088 3.089 1.264 1.265L17.265 12Z',
            },
        },
    ],
    reload: [
        {
            component: 'path',
            props: {
                d: 'm14.966 6.358-4.891-4.072L8.91 3.683l2.506 2.086.166 1.81-2.086 2.507 1.397 1.163 4.072-4.891Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'm12 5.677-.016-.001a8.182 8.182 0 1 0 7.38 8.142h-1.819A6.364 6.364 0 1 1 12 7.507v-1.83Z',
            },
        },
    ],
    rent: [
        {
            component: 'path',
            props: {
                d: 'M13.056 19.787h6.333v-9.523L12 4.518l-7.389 5.746v9.523h6.333V16h2.112v3.787Zm8.444 1.056a1.055 1.055 0 0 1-1.056 1.055H3.556A1.055 1.055 0 0 1 2.5 20.843V9.749a1.055 1.055 0 0 1 .407-.834l8.445-6.568a1.055 1.055 0 0 1 1.296 0l8.445 6.568a1.056 1.056 0 0 1 .407.834v11.094Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M6 2h2v5H6V2ZM13 11h4v2h-4v-2Z',
            },
        },
    ],
    rotation: [
        {
            component: 'path',
            props: {
                d: 'm20 10.586 1.828-1.829 1.415 1.415L19 14.414l-4.243-4.242 1.415-1.415L18 10.586V8a3 3 0 0 0-3-3h-4V3h4a5 5 0 0 1 5 5v2.586ZM13 9a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h10Zm-1 2H4v8h8v-8Z',
            },
        },
    ],
    save: [
        {
            component: 'path',
            props: {
                d: 'M7 19v-6h10v6h2V7.828L16.172 5H5v14h2ZM4 3h13l4 4v13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm5 12v4h6v-4H9Z',
            },
        },
    ],
    search: [
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M15.762 17.176a8.5 8.5 0 1 1 1.414-1.414l5.43 5.43-1.414 1.415-5.43-5.43ZM17 10.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Z',
                fillRule: 'evenodd',
            },
        },
    ],
    send: [
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M22.111 5.068a.4.4 0 0 1 .369.617l-8.395 12.873a.4.4 0 0 1-.618.064l-1.761-1.76-5.552 2.013.58-6.952-5.036-4.476a.4.4 0 0 1 .232-.697l20.181-1.682Zm-13.708 8.49 1.898 1.898-2.12.769.222-2.667Zm-.556-3.053 7.535-3.07-10.047.837 2.512 2.233ZM18.84 7.969l-5.321 8.16-4.258-4.257 9.58-3.903Z',
                fillRule: 'evenodd',
            },
        },
    ],
    'servers-and-website': [
        {
            component: 'path',
            props: {
                d: 'M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM8.01975 13C8.12359 15.6148 8.63032 17.9333 9.38254 19.562C6.55268 18.5826 4.44342 16.0596 4.06189 13H8.01975ZM10.0214 13C10.1143 15.15 10.5009 17.0092 11.0285 18.3283C11.3347 19.0937 11.6492 19.5788 11.8961 19.8399C11.9365 19.8826 11.9711 19.9155 12 19.9407C12.0289 19.9155 12.0635 19.8826 12.1039 19.8399C12.3508 19.5788 12.6653 19.0937 12.9715 18.3283C13.4991 17.0092 13.8857 15.15 13.9786 13H10.0214ZM13.9786 11H10.0214C10.1143 8.85001 10.5009 6.9908 11.0285 5.67171C11.3347 4.90634 11.6492 4.42118 11.8961 4.16007C11.9365 4.11741 11.9711 4.08451 12 4.05929C12.0289 4.08451 12.0635 4.11741 12.1039 4.16007C12.3508 4.42118 12.6653 4.90634 12.9715 5.67171C13.4991 6.9908 13.8857 8.85001 13.9786 11ZM15.9802 13C15.8764 15.6148 15.3697 17.9333 14.6175 19.562C17.4473 18.5826 19.5566 16.0596 19.9381 13H15.9802ZM19.9381 11H15.9802C15.8764 8.38522 15.3697 6.06674 14.6175 4.43801C17.4473 5.41736 19.5566 7.9404 19.9381 11ZM8.01975 11H4.06189C4.44342 7.9404 6.55268 5.41736 9.38254 4.43801C8.63032 6.06674 8.12359 8.38522 8.01975 11Z',
                fillRule: 'evenodd',
            },
        },
    ],
    services: [
        {
            component: 'path',
            props: {
                d: 'M2.1 18h20v2h-20v-2ZM14 7.82 15.026 5l1.88.684-1.026 2.82L14 7.818ZM9.905 7.82 8.88 5 7 5.684l1.026 2.82 1.88-.685ZM19 10.872 21.345 9l1.248 1.563-2.345 1.872L19 10.872ZM3.248 9l2.344 1.872-1.247 1.563L2 10.563 3.248 9Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M17 18a5 5 0 1 0-9.8 0H5.171a7 7 0 1 1 13.858 0H17Z',
            },
        },
    ],
    settings: [
        {
            component: 'path',
            props: {
                d: 'M2 12c0-.865.11-1.703.316-2.504A3 3 0 0 0 4.99 4.867a9.99 9.99 0 0 1 4.335-2.505 3 3 0 0 0 5.348 0 9.99 9.99 0 0 1 4.335 2.505 3 3 0 0 0 2.675 4.63 10.036 10.036 0 0 1 0 5.007 3 3 0 0 0-2.675 4.629 9.99 9.99 0 0 1-4.335 2.505 3 3 0 0 0-5.348 0 9.99 9.99 0 0 1-4.335-2.505 3 3 0 0 0-2.675-4.63A10.056 10.056 0 0 1 2 12Zm4.804 3c.63 1.091.81 2.346.564 3.524.408.29.842.541 1.297.75A4.993 4.993 0 0 1 12 18c1.26 0 2.438.471 3.335 1.274.455-.209.889-.46 1.297-.75A4.993 4.993 0 0 1 17.196 15a4.993 4.993 0 0 1 2.77-2.25 8.134 8.134 0 0 0 0-1.5A4.993 4.993 0 0 1 17.195 9a4.993 4.993 0 0 1-.564-3.524 7.988 7.988 0 0 0-1.297-.75A4.993 4.993 0 0 1 12 6a4.993 4.993 0 0 1-3.335-1.274 7.99 7.99 0 0 0-1.297.75A4.993 4.993 0 0 1 6.804 9a4.993 4.993 0 0 1-2.77 2.25 8.125 8.125 0 0 0 0 1.5A4.99 4.99 0 0 1 6.804 15ZM12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
            },
        },
    ],
    shield: [
        {
            component: 'path',
            props: {
                d: 'm12.182 2 7.47 1.66a.91.91 0 0 1 .711.887v9.08a5.454 5.454 0 0 1-2.429 4.537L12.182 22l-5.753-3.835a5.452 5.452 0 0 1-2.43-4.538v-9.08a.91.91 0 0 1 .713-.887L12.182 2Zm0 1.863L5.818 5.276v8.35c0 1.216.607 2.351 1.62 3.026l4.744 3.163 4.744-3.163a3.634 3.634 0 0 0 1.62-3.025v-8.35l-6.364-1.414Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M16.866 9.674 15.58 8.388l-4.5 4.5-2.571-2.572-1.286 1.286 3.858 3.857 5.785-5.785Z',
            },
        },
    ],
    shine: [
        {
            component: 'path',
            props: {
                d: 'M13.886 9.831c.083.195.317.293.5.186l.98-.57a.306.306 0 0 0 .134-.383 3.142 3.142 0 0 0-1.235-1.459C13.637 7.202 12.907 7 12.073 7c-.673 0-1.269.117-1.79.35-.51.233-.91.551-1.196.955-.278.394-.417.829-.417 1.304 0 1.623 1.112 2.605 3.335 2.946.807.125 1.368.296 1.682.51.314.207.47.485.47.835 0 .34-.17.614-.51.82-.341.206-.794.31-1.36.31-.69 0-1.272-.189-1.748-.566-.378-.3-.666-.711-.863-1.234-.076-.204-.32-.302-.506-.186l-1.02.637a.312.312 0 0 0-.128.38c.37.914.917 1.573 1.643 1.977.79.43 1.65.646 2.583.646.753 0 1.412-.121 1.977-.364.574-.25 1.013-.591 1.318-1.022.305-.43.457-.919.457-1.466 0-.807-.269-1.42-.807-1.842-.529-.43-1.367-.753-2.515-.969-.673-.125-1.206-.296-1.6-.51-.395-.216-.592-.512-.592-.888 0-.287.134-.525.403-.713.27-.197.628-.296 1.076-.296.935 0 1.575.406 1.92 1.217Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M2 6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6Zm4-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z',
                fillRule: 'evenodd',
            },
        },
    ],
    shipping: [
        {
            component: 'path',
            props: {
                d: 'M8.96456 18C8.72194 19.6961 7.26324 21 5.5 21C3.73676 21 2.27806 19.6961 2.03544 18H1V6C1 5.44772 1.44772 5 2 5H16C16.5523 5 17 5.44772 17 6V8H20L23 12.0557V18H20.9646C20.7219 19.6961 19.2632 21 17.5 21C15.7368 21 14.2781 19.6961 14.0354 18H8.96456ZM15 7H3V15.0505C3.63526 14.4022 4.52066 14 5.5 14C6.8962 14 8.10145 14.8175 8.66318 16H14.3368C14.5045 15.647 14.7296 15.3264 15 15.0505V7ZM17 13H21V12.715L18.9917 10H17V13ZM17.5 19C18.1531 19 18.7087 18.5826 18.9146 18C18.9699 17.8436 19 17.6753 19 17.5C19 16.6716 18.3284 16 17.5 16C16.6716 16 16 16.6716 16 17.5C16 17.6753 16.0301 17.8436 16.0854 18C16.2913 18.5826 16.8469 19 17.5 19ZM7 17.5C7 16.6716 6.32843 16 5.5 16C4.67157 16 4 16.6716 4 17.5C4 17.6753 4.03008 17.8436 4.08535 18C4.29127 18.5826 4.84689 19 5.5 19C6.15311 19 6.70873 18.5826 6.91465 18C6.96992 17.8436 7 17.6753 7 17.5Z',
            },
        },
    ],
    smile: [
        {
            component: 'path',
            props: {
                d: 'M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16.001A8 8 0 0 0 12 20Zm-5-7h2a3 3 0 0 0 6 0h2a5 5 0 1 1-10 0Zm1-2a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm8 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z',
            },
        },
    ],
    'sparkle-single': [
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'm12 6.615-1.06 2.686a2.911 2.911 0 0 1-1.64 1.64L6.616 12l2.686 1.06c.75.295 1.344.889 1.64 1.64L12 17.384l1.06-2.686c.295-.75.889-1.344 1.64-1.64L17.384 12l-2.686-1.06a2.911 2.911 0 0 1-1.64-1.64L12 6.616Zm.903-3c-.323-.82-1.483-.82-1.806 0L9.135 8.588a.97.97 0 0 1-.546.546l-4.975 1.962c-.819.323-.819 1.483 0 1.806l4.975 1.962a.97.97 0 0 1 .546.546l1.962 4.975c.323.819 1.483.819 1.806 0l1.962-4.975a.97.97 0 0 1 .546-.546l4.975-1.962c.819-.323.819-1.483 0-1.806L15.41 9.135a.97.97 0 0 1-.546-.546l-1.962-4.975Z',
                fillRule: 'evenodd',
            },
        },
    ],
    sparkles: [
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M9.9 1.7c-.3-.8-1.5-.8-1.8 0L7 4.5C6.6 5.7 5.7 6.6 4.5 7L1.7 8.1c-.8.3-.8 1.5 0 1.8L4.5 11c1.2.4 2.1 1.3 2.5 2.5l1.1 2.8c.3.8 1.5.8 1.8 0l1.1-2.8c.4-1.2 1.3-2.1 2.5-2.5l2.8-1.1c.8-.3.8-1.5 0-1.8L13.5 7c-1.2-.4-2.1-1.3-2.5-2.5L9.9 1.7ZM8.8 5.2l.2-.5.2.5c.6 1.7 1.9 3 3.6 3.6l.5.2-.5.2c-1.7.6-3 1.9-3.6 3.6l-.2.5-.2-.5c-.6-1.7-1.9-3-3.6-3.6L4.7 9l.5-.2c1.7-.6 3-1.9 3.6-3.6ZM19.9 16.5l1.8.7c.7.3.7 1.3 0 1.5l-1.8.7c-.7.3-1.2.8-1.5 1.5l-.7 1.8c-.2.7-1.2.7-1.5 0l-.7-1.8c-.3-.7-.8-1.2-1.5-1.5l-1.8-.7c-.7-.2-.7-1.2 0-1.5l1.8-.7c.7-.3 1.2-.8 1.5-1.5l.7-1.8c.2-.7 1.2-.7 1.5 0l.7 1.8c.3.7.8 1.2 1.5 1.5Zm-2.9-.6c-.4.9-1.1 1.7-2.1 2.1.9.4 1.7 1.2 2.1 2.1.4-.9 1.1-1.7 2.1-2.1-.9-.4-1.7-1.1-2.1-2.1Z',
                fillRule: 'evenodd',
            },
        },
    ],
    star: [
        {
            component: 'path',
            props: {
                d: 'm12.285 17.744-.244-.136-.245.136-5.877 3.29 1.313-6.606.054-.275-.205-.19L2.135 9.39l6.69-.793.277-.033.117-.254 2.822-6.116 2.821 6.116.117.254.278.033 6.69.793L17 13.963l-.206.19.055.275 1.312 6.606-5.877-3.29Zm4.355.422-.864-4.343 3.251-3.008.796-.736-1.076-.127-4.398-.521-1.854-4.021-.454-.985-.454.985L9.732 9.43l-4.397.52-1.077.128.796.736 3.251 3.008-.863 4.343-.212 1.063.946-.53 3.865-2.163 3.864 2.163.946.53-.211-1.063Z',
                stroke: 'currentColor',
                strokeWidth: 1,
            },
        },
    ],
    stars: [
        {
            component: 'path',
            props: {
                d: 'M12.04 18.18 5.219 22l1.523-7.67L1 9.023 8.765 8.1 12.041 1l3.275 7.1 7.765.922-5.74 5.309L18.863 22l-6.823-3.82Zm0-2.216 4.11 2.299-.919-4.617 3.457-3.198-4.676-.554-1.971-4.275-1.972 4.276-4.675.553 3.456 3.198-.918 4.617 4.109-2.3Z',
            },
        },
    ],
    store: [
        {
            component: 'path',
            props: {
                d: 'm21.46 8.22-2.728-4.715A1.009 1.009 0 0 0 17.856 3H6.216c-.359 0-.696.19-.875.505L2.613 8.22c-.09.158-.841 1.527-.393 3.065.292 1.01 1.033 1.818 2.178 2.402.247.123.786.325 1.504.325.786 0 1.942-.247 2.963-1.425.674.65 1.751 1.414 3.166 1.414 1.414 0 2.503-.763 3.165-1.414 1.021 1.167 2.166 1.425 2.963 1.425.73 0 1.269-.202 1.527-.336 1.134-.573 1.852-1.381 2.155-2.391.449-1.538-.303-2.907-.393-3.065h.011Zm-1.55 2.502c-.134.45-.505.831-1.11 1.145-.158.079-1.539.663-2.616-1.436a.987.987 0 0 0-.865-.54h-.022c-.348 0-.696.192-.876.495 0 .01-.976 1.594-2.38 1.594-1.39 0-2.367-1.572-2.367-1.594-.18-.315-.506-.505-.82-.505h-.078a.981.981 0 0 0-.876.55c-1.033 1.998-2.346 1.549-2.593 1.448-.617-.315-.988-.696-1.133-1.157-.214-.695.157-1.414.202-1.492L6.8 5.02h10.484l2.424 4.198s.416.786.202 1.504Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M3 19h18v2H3zM6 13v6H4v-6zM20 13v6h-2v-6z',
            },
        },
    ],
    suitcase: [
        {
            component: 'path',
            props: {
                d: 'M7.244 6.293v-2.85a.95.95 0 0 1 .95-.95h7.6a.95.95 0 0 1 .95.95v2.85h3.8a.95.95 0 0 1 .95.95v13.3a.95.95 0 0 1-.95.95h-17.1a.95.95 0 0 1-.95-.95v-13.3a.95.95 0 0 1 .95-.95h3.8Zm-2.85 10.45v2.85h15.2v-2.85h-15.2Zm0-1.9h15.2v-6.65h-15.2v6.65Zm4.75-10.45v1.9h5.7v-1.9h-5.7Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M8.668 11.993h-1.9V16.5h1.9v-4.507ZM16.5 11.993h-1.9V16.5h1.9v-4.507Z',
            },
        },
    ],
    sun: [
        {
            component: 'path',
            props: {
                d: 'M12 18a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm0-2a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM11 1h2v3h-2V1Zm0 19h2v3h-2v-3ZM3.515 4.929l1.414-1.414L7.05 5.636 5.636 7.05 3.515 4.93v-.001ZM16.95 18.364l1.414-1.414 2.121 2.121-1.414 1.414-2.121-2.121Zm2.121-14.85 1.414 1.415-2.121 2.121-1.414-1.414 2.121-2.121v-.001ZM5.636 16.95l1.414 1.414-2.121 2.121-1.414-1.414 2.121-2.121ZM23 11v2h-3v-2h3ZM4 11v2H1v-2h3Z',
            },
        },
    ],
    suppr: [
        {
            component: 'path',
            props: {
                d: 'M7.81 4h13.272a.918.918 0 0 1 .918.918v14.68a.918.918 0 0 1-.918.917H7.811a.918.918 0 0 1-.764-.408l-4.893-7.34a.917.917 0 0 1 0-1.019l4.893-7.34A.918.918 0 0 1 7.811 4Zm.492 1.835L4.02 12.258l4.282 6.422h11.863V5.835H8.302Zm5.44 5.125 2.595-2.595 1.298 1.298-2.595 2.595 2.595 2.594-1.298 1.299-2.595-2.596-2.594 2.596-1.299-1.299 2.596-2.595-2.596-2.594 1.299-1.298 2.594 2.595Z',
            },
        },
    ],
    switch: [
        {
            component: 'path',
            props: {
                d: 'M12 2c5.185 0 9.449 3.947 9.95 9h-2.012A8.001 8.001 0 0 0 5.385 7.5H8v2H2v-6h2V6a9.98 9.98 0 0 1 8-4ZM11.95 21C6.765 21 2.501 17.053 2 12h2.012a8.001 8.001 0 0 0 14.553 3.5H15.95v-2h6v6h-2V17a9.98 9.98 0 0 1-8 4Z',
            },
        },
    ],
    'tablet-and-mobile': [
        {
            component: 'path',
            props: {
                d: 'M18 8h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v5Zm-2 0V4H4v14h7V9a1 1 0 0 1 1-1h4Zm-3 2v10h6V10h-6Z',
            },
        },
    ],
    tag: [
        {
            component: 'path',
            props: {
                d: 'M13.1 2.1 3.201 3.515l-1.414 9.9 9.192 9.192a1 1 0 0 0 1.414 0l9.9-9.9a1 1 0 0 0 0-1.414L13.1 2.1Zm-.707 2.122L20.172 12l-8.486 8.485-7.778-7.778 1.06-7.425 7.425-1.06Zm-2.12 6.364a2 2 0 1 0-2.83-2.829 2 2 0 0 0 2.83 2.829Z',
            },
        },
    ],
    'take-picture': [
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z',
                fillRule: 'evenodd',
            },
        },
    ],
    tax: [
        {
            component: 'path',
            props: {
                d: 'M15 4H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M9.657 11H6v.829h1.371V15h.915v-3.171h1.371V11ZM9.44 15h1l.309-.829h1.84l.308.829h1l-1.571-4H11.01L9.44 15Zm1.617-1.657.611-1.634.612 1.634h-1.223ZM14.204 15h1.058l.971-1.457.971 1.457h1.058l-1.515-2.171L18.033 11h-1.057l-.743 1.143L15.49 11h-1.057l1.286 1.829L14.205 15Z',
            },
        },
    ],
    team: [
        {
            component: 'path',
            props: {
                d: 'M2 22a7.62 7.62 0 0 1 15.238 0h-1.905a5.714 5.714 0 1 0-11.428 0H2Zm7.619-8.571a5.713 5.713 0 0 1-5.714-5.715A5.713 5.713 0 0 1 9.619 2a5.713 5.713 0 0 1 5.714 5.714A5.713 5.713 0 0 1 9.62 13.43Zm0-1.905a3.808 3.808 0 0 0 3.81-3.81 3.809 3.809 0 0 0-3.81-3.81 3.808 3.808 0 0 0-3.81 3.81 3.808 3.808 0 0 0 3.81 3.81Zm7.89 3.527A7.621 7.621 0 0 1 22 22h-1.905a5.715 5.715 0 0 0-3.368-5.212l.782-1.738Zm-.656-10.753a5.238 5.238 0 0 1 1.873 8.377 5.237 5.237 0 0 1-3.393 1.685v-1.917a3.333 3.333 0 0 0 .992-6.294l.528-1.85Z',
            },
        },
    ],
    tick: [
        {
            component: 'path',
            props: {
                d: 'M8.931 15.92 20.459 4.391 22 5.931 8.931 19 2 12.07l1.54-1.54 5.391 5.39Z',
            },
        },
    ],
    'tick-in-circle': [
        {
            component: 'path',
            props: {
                d: 'M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16.001A8 8 0 0 0 12 20Zm-.997-4L6.76 11.757l1.414-1.414 2.829 2.829 5.656-5.657 1.415 1.414L11.003 16Z',
            },
        },
    ],
    'tick-in-filled-circle': [
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM7 11.9995L11.1252 16L18 9.33318L16.6243 8L11.1252 13.3336L8.37476 10.6664L7 11.9995Z',
                fillRule: 'evenodd',
            },
        },
    ],
    timer: [
        {
            component: 'path',
            props: {
                d: 'm17.618 5.968 1.453-1.453 1.414 1.414-1.453 1.453a9 9 0 1 1-1.414-1.414ZM12 20a7.001 7.001 0 0 0 4.95-11.95A7 7 0 1 0 12 20ZM11 8h2v6h-2V8ZM8 1h8v2H8V1Z',
            },
        },
    ],
    toolbox: [
        {
            component: 'path',
            props: {
                d: 'M7 7V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h4Zm-3 7v5h16v-5H4Zm0-2h16V9H4v3Zm5-7v2h6V5H9Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M8 15.5h8v2H8v-2Z',
            },
        },
    ],
    'transaction-in': [
        {
            component: 'path',
            props: {
                d: 'M6.522 15.985V5.361H4.5v14.141l14.142.001v-2.022H7.855L19.57 5.764 18.157 4.35 6.522 15.985Z',
            },
        },
    ],
    'transaction-out': [
        {
            component: 'path',
            props: {
                d: 'M15.985 6.45H5.361V4.43h14.141l.001 14.142h-2.022V7.783L5.764 19.5 4.35 18.086 15.985 6.45Z',
            },
        },
    ],
    transfer: [
        {
            component: 'path',
            props: {
                d: 'M13 17V5.83l6.071 6.069 1.414-1.414L12 2l-8.485 8.486L4.929 11.9 11 5.828V17h2ZM19 22h2v-3H3v3h2v-1h14v1Z',
            },
        },
    ],
    'transfer-money-out': [
        {
            component: 'path',
            props: {
                d: 'M6 9H3a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1h-3v2h2v9H4v-9h2V9Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M7 6.95 11.95 2l4.95 4.95-1.414 1.414-2.537-2.536L12.95 15h-2V5.828L8.414 8.364 7 6.95Z',
            },
        },
    ],
    transportation: [
        {
            component: 'path',
            props: {
                d: 'm17.2 19.511 1.8 1.5v.5H5v-.5l1.8-1.5H5a2 2 0 0 1-2-2v-11a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v11a2 2 0 0 1-2 2h-1.8Zm-4.2-15v6h6v-4a2 2 0 0 0-2-2h-4Zm-2 0H7a2 2 0 0 0-2 2v4h6v-6Zm8 8H5v5h14v-5Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M8.488 15.205a1.22 1.22 0 1 1-2.44 0 1.22 1.22 0 0 1 2.44 0ZM18.013 15.22a1.22 1.22 0 1 1-2.44 0 1.22 1.22 0 0 1 2.44 0Z',
            },
        },
    ],
    trash: [
        {
            component: 'path',
            props: {
                d: 'M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3Zm1 2H6v12h12V8Zm-9 3h2v6H9v-6Zm4 0h2v6h-2v-6ZM9 4v2h6V4H9Z',
            },
        },
    ],
    unlock: [
        {
            component: 'path',
            props: {
                d: 'M7 10h13a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h1V9a7 7 0 0 1 13.262-3.131l-1.789.894A5 5 0 0 0 7 9v1Zm-2 2v8h14v-8H5Zm5 3h4v2h-4v-2Z',
            },
        },
    ],
    'user-plus': [
        {
            component: 'path',
            props: {
                d: 'M12 13.429a5.713 5.713 0 0 1-5.715-5.715A5.713 5.713 0 0 1 11.999 2a5.713 5.713 0 0 1 5.714 5.714A5.713 5.713 0 0 1 12 13.43Zm0-1.905a3.808 3.808 0 0 0 3.809-3.81 3.808 3.808 0 0 0-3.81-3.81 3.808 3.808 0 0 0-3.81 3.81 3.808 3.808 0 0 0 3.81 3.81ZM4.38 22A7.62 7.62 0 0 1 12 14.381v1.905A5.714 5.714 0 0 0 6.284 22H4.38ZM16.263 14.381v2.857h-2.842v1.905h2.842V22h1.895v-2.857H21v-1.905h-2.842v-2.857h-1.895Z',
            },
        },
    ],
    utilities: [
        {
            component: 'path',
            props: {
                d: 'M13 18v2l-.5-.5c-.53 0-.125-.125-.5-.5s-1 1.53-1 1v-2H8a4 4 0 0 1-4-4V7a1 1 0 0 1 1-1h3V2h2v4h4V2h2v4h3a1 1 0 0 1 1 1v7a4 4 0 0 1-4 4h-3Zm-5-2h8a2 2 0 0 0 2-2v-3.5L6 7v7a2 2 0 0 0 2 2Zm10-8H6V7l12 3.5V8Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M13 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 18h2v4h-2v-4Z',
            },
        },
    ],
    vehicle: [
        {
            component: 'path',
            props: {
                d: 'M19 20H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V11l2.48-5.788A2 2 0 0 1 6.32 4h11.36a2 2 0 0 1 1.838 1.212L22 11v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1Zm1-7H4v5h16v-5ZM4.176 11h15.648l-2.143-5H6.32l-2.144 5Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M8.54 15.54a1.22 1.22 0 1 1-2.44.001 1.22 1.22 0 0 1 2.44 0ZM18.066 15.557a1.22 1.22 0 1 1-2.441 0 1.22 1.22 0 0 1 2.44 0Z',
            },
        },
    ],
    'vertical-ellipsis': [
        {
            component: 'path',
            props: {
                d: 'M13.521 4.056v3.2h-3.2v-3.2h3.2ZM13.521 10.456v3.2h-3.2v-3.2h3.2ZM13.521 16.856v3.2h-3.2v-3.2h3.2Z',
            },
        },
    ],
    wallet: [
        {
            component: 'path',
            props: {
                d: 'M20.996 7.173h.945v9.444h-.945v2.834a.945.945 0 0 1-.944.944h-17a.945.945 0 0 1-.945-.944V4.34a.944.944 0 0 1 .945-.945h17a.944.944 0 0 1 .944.945v2.833Zm-1.889 9.444h-5.666a4.722 4.722 0 1 1 0-9.444h5.666V5.284H3.997v13.222h15.11v-1.889Zm.945-1.889V9.063H13.44a2.833 2.833 0 1 0 0 5.667h6.61Zm-6.611-3.777h2.833v1.889h-2.833v-1.89Z',
            },
        },
    ],
    warning: [
        {
            component: 'path',
            props: {
                d: 'M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16.001A8 8 0 0 0 12 20Z',
            },
        },
        {
            component: 'path',
            props: {
                d: 'M11 17h2v-2h-2v2ZM11 13h2V7h-2v6Z',
            },
        },
    ],
    warranty: [
        {
            component: 'path',
            props: {
                d: 'M17 15.245v6.872a.5.5 0 0 1-.757.429L12 20l-4.243 2.546a.5.5 0 0 1-.757-.43v-6.87a8 8 0 1 1 10 0v-.001Zm-8 1.173v3.05l3-1.8 3 1.8v-3.05A7.978 7.978 0 0 1 12 17a7.978 7.978 0 0 1-3-.582ZM12 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z',
            },
        },
    ],
    wifi: [
        {
            component: 'path',
            props: {
                d: 'M2 7.553A15.934 15.934 0 0 1 12.054 4c3.808 0 7.306 1.33 10.054 3.552l-1.547 1.915a13.482 13.482 0 0 0-8.507-3.005 13.487 13.487 0 0 0-8.507 3.005L2 7.553ZM5.867 12.341a9.805 9.805 0 0 1 6.187-2.187c2.344 0 4.496.818 6.187 2.186l-1.547 1.915a7.354 7.354 0 0 0-4.64-1.64 7.355 7.355 0 0 0-4.64 1.64L5.867 12.34ZM14 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z',
            },
        },
    ],
    youtube: [
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M10.928 7.971c-1.148-.635-2.54.22-2.54 1.56v4.938c0 1.34 1.392 2.196 2.54 1.56l4.458-2.47c1.208-.668 1.208-2.45 0-3.119l-4.458-2.469Zm-.872 1.56c0-.017.003-.025.005-.029a.061.061 0 0 1 .022-.02.06.06 0 0 1 .027-.01c.005 0 .013 0 .027.008l4.459 2.47c.016.009.02.016.022.02a.064.064 0 0 1 .007.03.064.064 0 0 1-.007.03c-.002.004-.006.011-.022.02l-4.459 2.47c-.014.008-.022.008-.027.008a.06.06 0 0 1-.027-.01.061.061 0 0 1-.022-.02.054.054 0 0 1-.005-.029V9.531Z',
                fillRule: 'evenodd',
            },
        },
        {
            component: 'path',
            props: {
                clipRule: 'evenodd',
                d: 'M2 7.429C2 5.535 3.492 4 5.333 4h13.334C20.507 4 22 5.535 22 7.429v9.142C22 18.465 20.508 20 18.667 20H5.333C3.493 20 2 18.465 2 16.571V7.43Zm3.333-1.715h13.334c.92 0 1.666.768 1.666 1.715v9.142c0 .947-.746 1.715-1.666 1.715H5.333c-.92 0-1.666-.768-1.666-1.715V7.43c0-.947.746-1.715 1.666-1.715Z',
                fillRule: 'evenodd',
            },
        },
    ],
};
exports.iconNames = Object.keys(exports.icons);
